import React from 'react'
import { useTranslation } from 'react-i18next'
import { ListPagePill, RISK_HORIZON_PILL } from './ListPageCells'

interface TagProps {
  priority: number
  size?: 'md' | 'sm'
}

const TagPriorityRisks: React.FC<TagProps> = ({ priority, size = 'sm' }) => {
  const { t } = useTranslation()
  const tone = RISK_HORIZON_PILL[priority] ?? RISK_HORIZON_PILL[3]
  const label = t(`prioritRisk.${priority}`, {
    defaultValue: String(priority),
  })

  return (
    <ListPagePill
      label={label}
      bg={tone.bg}
      color={tone.color}
      size={size}
    />
  )
}

export default TagPriorityRisks
